import React, { useCallback } from 'react';

import { useIntl } from 'react-intl';
import styled from 'styled-components';

import { Tab, TabPanel, Tabs } from 'components/tabs';
import { useAndroidBackButton } from 'hooks/use-android-back-button';
import useMaximumScreenBrightness from 'hooks/use-maximum-screen-brightness';
import { DrawerTab, useUIContext } from 'state/ui';

import { messages } from './messages';
import { ScanRewards } from './scan-rewards';
import LoyaltyTimCard from './tim-card';

interface ILoyalty {
  onDismiss: (e?: React.SyntheticEvent) => void;
}

const Section = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  padding-top: 8px;
  height: 100%;
  flex: 1;

  ${Styles.desktop`
    max-width: 350px;
    width: 350px;
  `}
`;

interface IAppBar {
  children: React.ReactNode;
}

const AppBarStyle = styled.header`
  display: flex;
  width: 80%;
  padding: 0;
`;

export const AppBar = ({ children }: IAppBar) => {
  return <AppBarStyle>{children}</AppBarStyle>;
};

const StyledTabLine = styled.div`
  border: solid 1px #000;
  height: 1px;
  opacity: 0.2;
  width: 100%;
  position: relative;
  bottom: 2px;
  opacity: 0.1;
`;

function a11yProps(index: any) {
  return {
    id: `drawer-tab-${index}`,
    ariaControls: `drawer-tabpanel-${index}`
  };
}

const Loyalty: React.FC<ILoyalty> = ({ onDismiss }) => {
  const { formatMessage } = useIntl();
  const { activeDrawerTab, setActiveDrawerTab } = useUIContext();
  const handleChange = useCallback(
    (event: React.ChangeEvent<{}>, newValue: DrawerTab) => {
      event.preventDefault();
      setActiveDrawerTab(newValue);
    },
    [setActiveDrawerTab]
  );

  const inactiveStyle = {
    opacity: 0.5
  };

  useMaximumScreenBrightness();
  useAndroidBackButton(onDismiss);

  return (
    <Section>
      <AppBar>
        <Tabs
          color="inverted"
          inactiveStyle={inactiveStyle}
          selectedIndex={activeDrawerTab}
          onChange={handleChange}
        >
          <Tab label={formatMessage(messages.timsRewardsHeader)} {...a11yProps(0)} value={0} />
          <Tab label={formatMessage(messages.timsCardHeader)} {...a11yProps(1)} value={1} />
        </Tabs>
      </AppBar>
      <StyledTabLine />
      <TabPanel
        value={activeDrawerTab}
        index={0}
        id={`drawer-tabpanel-${0}`}
        ariaLabeledBy={`drawer-tab-${0}`}
      >
        <ScanRewards onDismiss={onDismiss} />
      </TabPanel>
      <TabPanel
        value={activeDrawerTab}
        index={1}
        id={`drawer-tabpanel-${1}`}
        ariaLabeledBy={`drawer-tab-${1}`}
      >
        <LoyaltyTimCard onDismiss={onDismiss} />
      </TabPanel>
    </Section>
  );
};

export default Loyalty;
